import { defineMessages } from 'react-intl';

export default defineMessages({
  userNotificationsPopoverTitle: {
    id: 'app.userNotificationsPopoverTitle',
    defaultMessage: 'Notifications',
  },
  userNotificationsBtnGroupItemAll: {
    id: 'app.userNotificationsBtnGroupItemAll',
    defaultMessage: 'All',
  },
  userNotificationsBtnGroupItemUnread: {
    id: 'app.userNotificationsBtnGroupItemUnread',
    defaultMessage: 'Unread',
  },
  userNotificationsMarkAllAsRead: {
    id: 'app.userNotificationsMarkAllAsRead',
    defaultMessage: 'Mark all as read',
  },
  userNotificationsMarkAsRead: {
    id: 'app.userNotificationsMarkAsRead',
    defaultMessage: 'Mark as read',
  },
  userNotificationsMarkAsUnread: {
    id: 'app.userNotificationsMarkAsUnread',
    defaultMessage: 'Mark as unread',
  },
  userNotificationsInfo: {
    id: 'app.userNotificationsInfo',
    defaultMessage: "That's all your notifications from the last 30 days",
  },
  userNotificationsUnreadEmpty: {
    id: 'app.userNotificationsUnreadEmpty',
    defaultMessage: 'You have no unread notifications',
  },
  userNotificationsAnyEmpty: {
    id: 'app.userNotificationsAllEmpty',
    defaultMessage: 'You have no any notifications',
  },
});
